export enum KYC_TIER_EVENT {
  INITIAL_CHECK = 't1.initial_checks',
}
